<template>
  <zj-layout-container>
    <zj-layout-main>
      <div class="dataBox dataBox-weather">
        <div class="grid">
          <ul class="tab_ul clearfix">
            <li :class="{ cur: selectindex == 0 }" @click="handleTabChange(0)">
              <a href="javascript:;">今天</a>
            </li>
            <li :class="{ cur: selectindex == 1 }" @click="handleTabChange(1)">
              <a href="javascript:;">7天预报</a>
            </li>
            <li class="locationselect">
              <!-- <div>
                <span class="icon"></span>
                <span class="city-name">{{ this.query.cityname }}</span>
               
              </div> -->

              <el-select
                v-model="cityname"
                placeholder="请选择"
                @change="cityChange"
              >
                <el-option
                  v-for="(item, index) in cityOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </li>
          </ul>
          <div class="tab_body clearfix">
            <div class="tabCon">
              <div
                class="tabContent tabContent1 clearfix"
                style="display: block"
              >
                <div class="weather-tabbody weather-detail clearfix">
                  <div
                    class="weather-realtime clearfix"
                    style="background-color: #021132"
                  >
                    <div
                      v-bind:class="
                        'weather-icon weather-icon-' + d.realtime.img
                      "
                    >
                      <i
                        v-bind="
                          d.realtime.weather +
                          ',' +
                          d.city +
                          '（来源：' +
                          d.source +
                          '）'
                        "
                      ></i>
                    </div>
                    <div class="weather-temp">
                      <span>{{ d.realtime.temp }}℃</span>
                    </div>
                    <div class="weather-pm25">
                      <span title="空气质量"
                        >{{ d.realtime.aqi }} {{ d.realtime.aqa }}</span
                      >
                    </div>
                    <div class="weather-humi">
                      <i></i><span>湿度</span><span>{{ d.realtime.sd }}%</span>
                    </div>
                    <div class="weather-wind">
                      <i></i><span>{{ d.realtime.wd }}</span
                      ><span>{{ d.realtime.ws }}</span>
                    </div>
                  </div>
                  <div class="weather-hours24 clearfix">
                    <ul class="clearfix">
                      <li
                        v-for="(item, index) in d.hour24.slice(0, 13)"
                        :key="index"
                      >
                        <div>
                          <div class="x-hour">
                            <span style="color: #fff"
                              >{{
                                new Date(
                                  item.time.replace(" ", "T")
                                ).getHours()?new Date(
                                  item.time.replace(" ", "T")
                                ).getHours()+"时":"暂无"
                              }}</span
                            >
                          </div>
                          <div class="x-weather-name">
                            <span style="color: #fff">{{ item.weather }}</span>
                          </div>
                          <div v-bind:class="'x-icon weather-icon-' + item.img">
                            <i v-bind:title="item.weather"></i>
                          </div>
                          <div class="x-wind">
                            <span style="color: #fff">{{ item.wd }}</span>
                          </div>
                          <div class="x-wind-level">
                            <span style="color: #fff">{{ item.ws }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div class="weather-hours24-chart">
                      <div class="echart"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tabContent tabContent2 clearfix"
                style="display: block"
              >
                <div class="weather-tabbody weather-7day clearfix">
                  <ul class="clearfix">
                    <li
                      v-bind:class="item.dateName == '今天' ? 'today' : ''"
                      :key="index"
                      v-for="(item, index) in d.day7.slice(0, 8)"
                    >
                      <div>
                        <div class="x-hour">
                          <span>{{ item.monthAndDay }}</span>
                        </div>
                        <div class="x-datename">
                          <span>{{ item.dateName }}</span>
                        </div>
                        <div class="x-weather-name">
                          <span>{{ item.weather }}</span>
                        </div>
                        <div v-bind:class="'x-icon weather-icon-' + item.img">
                          <i v-bind:title="item.weather"></i>
                        </div>
                        <div class="x-temp">
                          <span>{{
                            item.temp0 && item.temp1
                              ? item.temp0 + "℃~" + item.temp1 + "℃"
                              : ""
                          }}</span>
                        </div>
                        <div class="x-wind">
                          <span>{{ item.wd ? item.wd : "暂无" }}</span>
                        </div>
                        <div class="x-wind-level">
                          <span>{{ item.ws ? item.ws : "暂无" }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="weather-7day-chart">
                    <div class="echart"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="weather-indexes clearfix">
              <ul class="clearfix">
                <li
                  v-for="(item, index) in d.indexes.slice(0, 10)"
                  :key="index"
                >
                  <div class="weather-index">
                    <i
                      v-bind:class="
                        'weather-index-icon weather-index-icon-' + item.abbr
                      "
                    ></i>
                    <span class="weather-index-value" style="color: #fff">{{
                      item.level
                    }}</span>
                    <span class="weather-index-name">{{ item.name }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
// import MyApis from "../../apis";
import { getWeathermoji } from '@/api/src/equipmentDataStat'
export default {
  name: "ZJWeathersHomeMain",
  controller: "UI",
  action: "WeathersHome",
  props: {
    query: {
      city: {
        type: String,
        required: true,
        default: "太昊陵",
      },
      // cityname: {
      //   type: String,
      //   default: "",
      // },
    },
  },
  data() {
    return {
      d: {
        cityid: "",
        city: "",
        sourceid: "",
        source: "",
        time: new Date(),
        realtime: {},
        indexes: [],
        hour24: [],
        day7: [],
      },
      selectindex: 0,
      cityOptions: [
        { value: "周口市", label: "太昊陵" },
        { value: "郑州市", label: "郑州市" },
      ],
      cityname: global.$config.app.weatherCityName
    };
  },
  created: function () {},
  mounted: function () {
    // this.getWeather(this.cityname);
    this.getWeather();
    // this.logInfo.ActionName = "天气信息查询";
    // this.logInfo.LogMessage = "天气信息查询";
    // this.logInfo.ModuleName = "天气系统";
    // this.logInfo.PageName = "天气信息页面";
    // this.addOperationLog();
  },
  methods: {
    getWeather () {
      let that = this;
      // let searchInfo = {
      //   City: cityname,
      //   Source: "",
      // };

      // new MyApis.WeatherApi()
      //   .GetWeather(searchInfo)
      //   .then((r) => {
      //     r = r.data.Data;
      //     console.log(r);
      //     r.day7.forEach(function (item) {
      //       item.dateName = that.getDateName(item.time);
      //       item.monthAndDay = that.getMonthAndDay(item.time);
      //     });
      //     this.d = r;
      //     this.handleTabChange(0);
      //   })
      //   .catch((e) => {
      //     console.log(this, e);
      //     this.$message({
      //       type: "error",
      //       message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
      //     });
      //   });

        getWeathermoji({"city":this.cityname}).then(res=>{
          console.log("天气",res)
          if(res.code==200){
            let data = res.data;
            data.day7.forEach(function (item) {
              item.dateName = that.getDateName(item.time);
              item.monthAndDay = that.getMonthAndDay(item.time);
            });
            this.d = data;
            this.handleTabChange(0);
          }
        })
    },
    cityChange(value) {
      this.getWeather(value);
    },
    handleTabChange: function (i) {
      this.selectindex = i;
      if (i == 0) {
        // eslint-disable-next-line no-undef
        $(".tabContent2").hide();
        // eslint-disable-next-line no-undef
        $(".tabContent1").show();
        this.bindHours24Weather(this.d);
      } else if (i == 1) {
        // eslint-disable-next-line no-undef
        $(".tabContent1").hide();
        // eslint-disable-next-line no-undef
        $(".tabContent2").show();
        this.bind7DayWeatherDetail(this.d);
      }
    },
    bindHours24Weather: function (d) {
     // if (d.hour24.length == 0) return;
      if (d.hour24.length < 13) {
        for (var i = d.hour24.length; i < 13; i++) {
          d.hour24.push({
            img: "",
            weather: "",
            temp: "",
            temp0: "",
            temp1: "",
            sd: "",
            ws: "",
            wd: "",
            aqi: "",
            aqa: "",
            time: "",
          });
        }
      }

      var opt = {
        color: ["#28abff"],
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{c}℃",
          position: "top",
          backgroundColor: "rgba(50,50,50,0)",
          borderWidth: 0,
          padding: 0,
          textStyle: {
            color: "#666",
          },
        },
        grid: {
          left: 0,
          right: 0,
          top: 10,
          bottom: 0,
        },
        xAxis: {
          type: "category",
          data: [],
          show: false,
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            data: [],
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            label: {
              normal: {
                show: true,
                position: "bottom",
                color: "#fff",
                fontSize: 20,
                formatter: "{c}℃",
              },
            },
          },
        ],
      };

      // eslint-disable-next-line no-redeclare
      for (var i = 0, len = Math.min(d.hour24.length, 13); i < len; i++) {
        opt.xAxis.data.push(new Date(d.hour24[i].time).getHours());
        opt.series[0].data.push(parseInt(d.hour24[i].temp));
      }

      // eslint-disable-next-line no-undef
      var dom = $(".weather-hours24-chart > div")[0];
      // eslint-disable-next-line no-undef
      var chart = echarts.getInstanceByDom(dom);
      if (!chart) {
        // eslint-disable-next-line no-undef
        chart = echarts.init(dom);
      }
      chart.setOption(opt);
      chart.resize();
    },
    bind7DayWeatherDetail: function (d) {
      if (d.day7.length < 8) {
        for (var i = d.day7.length; i < 8; i++) {
          d.day7.push({
            img: "",
            weather: "",
            temp: "",
            temp0: "",
            temp1: "",
            sd: "",
            ws: "",
            wd: "",
            aqi: "",
            aqa: "",
            time: "",
          });
        }
      }
      var opt = {
        tooltip: { show: false },
        legend: { show: false },
        grid: { left: 0, right: 0, top: 10, bottom: 0 },
        xAxis: [
          {
            show: false,
            type: "category",
            data: [],
          },
        ],
        yAxis: [
          {
            show: false,
            type: "value",
          },
        ],
        series: [
          {
            name: "最低温度",
            type: "bar",
            stack: "温度",
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0)",
              },
            },
          },
          {
            name: "最高温度",
            type: "bar",
            stack: "温度",
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "#28abff",
                barBorderRadius: 10,
              },
            },
          },
        ],
      };

      var min = 0,
        max = 0;
      // eslint-disable-next-line no-redeclare
      for (var i = 0, len = Math.min(d.day7.length, 8); i < len; i++) {
        opt.xAxis[0].data.push(this.getDateName(new Date(d.day7[i].time)));
        var value0 = parseInt(d.day7[i].temp0) || 0,
          value1 = parseInt(d.day7[i].temp1) || 0,
          total = value0 + value1;
        opt.series[0].data.push(value0);
        opt.series[1].data.push(value1);
        if (min === 0 || min > value0) min = value0;
        if (max === 0 || max < total) max = total;
      }

      opt.yAxis[0].min = min - 1;
      opt.yAxis[0].max = max + 1;

      // eslint-disable-next-line no-undef
      var dom = $(".weather-7day-chart > div")[0];
      // eslint-disable-next-line no-undef
      var chart = echarts.getInstanceByDom(dom);
      if (!chart) {
        // eslint-disable-next-line no-undef
        chart = echarts.init(dom);
      }
      chart.setOption(opt);
      chart.resize();
    },
    getDateName: function (dt) {
      var WEEKS = ["日", "一", "二", "三", "四", "五", "六"];

      if (!dt) return "";
      if (typeof dt === "string") dt = new Date(dt);
      var today = new Date(),
        yesterday = new Date(today.setDate(today.getDate() - 1)),
        tomorrow = new Date(today.setDate(today.getDate() + 1));
      if (
        dt.getMonth() == yesterday.getMonth() &&
        dt.getDate() == yesterday.getDate()
      )
        return "昨天";
      else if (
        dt.getMonth() == today.getMonth() &&
        dt.getDate() == today.getDate()
      )
        return "今天";
      else if (
        dt.getMonth() == tomorrow.getMonth() &&
        dt.getDate() == tomorrow.getDate()
      )
        return "明天";
      else return "周" + WEEKS[dt.getDay()];
    },
    getMonthAndDay: function (dt) {
      if (!dt) return "";
      if (typeof dt === "string") dt = new Date(dt);
      return "" + (dt.getMonth() + 1) + "月" + dt.getDate() + "日";
    },
  },
};
</script>
